import { useNavigate, useLocation } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuLinkItem,
} from "../components/ui/DropdownMenu";
import { modulesByGroup, isNavPathActive, type NavItem } from "./navConfig";

export function MenuBarModulesMenu() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const groups = modulesByGroup();

  const renderItem = (item: NavItem, indent = false) => (
    <DropdownMenuLinkItem
      key={item.id}
      active={isNavPathActive(pathname, item.path)}
      onNavigate={() => navigate(item.path)}
    >
      <span className={indent ? "pl-2" : ""}>
        {item.icon ? `${item.icon} ` : ""}
        {item.label}
      </span>
    </DropdownMenuLinkItem>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>Modules ▾</DropdownMenuTrigger>
      <DropdownMenuContent minWidth={240}>
        {groups.map((g, gi) => (
          <div key={g.group}>
            {gi > 0 ? <DropdownMenuSeparator /> : null}
            <DropdownMenuLabel>{g.label}</DropdownMenuLabel>
            {g.items.map((mod) => (
              <div key={mod.id}>
                {renderItem(mod)}
                {mod.children?.map((child) => renderItem(child, true))}
              </div>
            ))}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
